module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/325705/target02-ea10b73c72c43f462924a795574258af.png";